import { AbstractControl, ValidationErrors } from '@angular/forms';

import { delay, map, Observable, of, switchMap } from 'rxjs';

import { TellentMembersHttpClient } from '../store/tellent-members.http';

export function existingMemberValidator(tellentMembersHttpClient: TellentMembersHttpClient) {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const value = control.value;

    return of(control.value).pipe(
      delay(250),
      switchMap(() => tellentMembersHttpClient.fetchMemberByEmail(value)),
      map(members => {
        const existingMember = members.find(member => member.email === value);
        return !!existingMember ? { existingMember } : null;
      }),
    );
  };
}
